exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feature-box {\n  text-align: center;\n}\n\n.feature-box .features-big .fa {\n  font-size: 4rem;\n}\n\n.rounded-circle {\n  width: 8rem;\n  height: 8rem;\n  border: 5px solid #373a3c;\n  padding-top: 1.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/shipping-services/shipping-buy/shipping-buy.component.css
// module id = 907
// module chunks = 3